/* eslint-disable max-len */
var ICON_UI_CHECKMARK = {
  v2: true,
  "default": 'M1 14.7539L5.49167 21.1445C5.66204 21.3997 5.89074 21.6103 6.15872 21.759C6.4267 21.9076 6.72622 21.99 7.03235 21.9991C7.33847 22.0083 7.64236 21.944 7.91871 21.8117C8.19507 21.6794 8.4359 21.4828 8.62117 21.2383L23 3',
  globetrotter: 'M22.125 4.5L9.33 19.5L1.875 12.9825'
};

export { ICON_UI_CHECKMARK };
//# sourceMappingURL=ICON_UI_CHECKMARK.js.map
